import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';

export default function InfoFab({ hiddenOnMobile }: { hiddenOnMobile?: boolean }) {
  return (
    <Link
      to="/about"
      className={`info-fab${hiddenOnMobile ? ' fab--hidden-mobile' : ''}`}
      aria-label="Info & Contact"
      title="Info & Contact"
    >
      <Info size={20} />
    </Link>
  );
}
